module.exports = __webpack_public_path__ + "media/earthloop.892f2c15.webm";